const lan = /^.{8,32}$/
const number6 = /^\d{6}$/
const number = /^[0-9]*$/

const phone = /^\d{6}/
const email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
const pwd = /^(?:(?=.*[A-Za-z])(?=.*[0-9])).{8,24}$/

export default {
  lan,
  number6,
  number,
  phone,
  email,
  pwd,
}
